import React from 'react';
import RangeForm from '../components/RangeForm';

// Height range slider
const Range = () => (
    <div className="range-wrapper">
        <div className="category-head">
            <p>1. Drag to Adjust Height</p>
        </div>
        <RangeForm parameter='height'/>
    </div>
)

export default Range;


// WEBPACK FOOTER //
// ./src/components/Range.js